import React from "react";
import { BsCloudDownload } from "react-icons/bs";
import ToolMenuIconButton from "../../../../common/ToolMenuIconButton";

export interface IProps {
  onClick?: () => void;
}

class DownloadConfFileButton extends React.Component<IProps> {
  private readonly Icon = <BsCloudDownload />
  private readonly Tooltip = "Download configuration";

  render(): JSX.Element {
    return (
      <div>
        <ToolMenuIconButton          
          onClick={this.props.onClick}
          icon={this.Icon}
          tooltip={this.Tooltip}
        />
      </div>
    );
  }
}

/**
 * 設定ファイルダウンロードボタン
 */
export default DownloadConfFileButton;
